var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-splash',[_c('div',{staticClass:"h-full w-96"},[_c('button',{on:{"click":function($event){return _vm.submit()}}},[_c('img',{attrs:{"src":_vm.buttonUrl}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }